<template>
  <div class="sign-info">
    <templagte v-if="+$route.query.ywtLayoutStyle === 1">
      <role-tab :ywtTab="true" />
    </templagte>
    <div class="iframe_box">
      <iframe ref="ywtIframeRef" :style="{width: '100%', height: +$route.query.ywtLayoutStyle === 1 ? '76vh' : '86vh'}" :src="iframeSrc" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
  import RoleTab from "@/components/role-tab";
  import {ApiMethods} from "../assets/js/http-serve/http-methods";

  export default {
    name: "ywtSystem",
    components: {
      RoleTab,
    },
    props: {
      menuActive: {
        type: [Number , String]
      }
    },
    data() {
      return {
        iframeSrc: '',
      }
    },
    mounted() {
      this.init();
      window.addEventListener('message', this.ywtCallBackFn)
    },
    beforeDestroy() {
      window.removeEventListener('message', this.ywtCallBackFn)
    },
    computed: {
      currentAuthUser () {
        return this.$store.getters.currentAuthUser || {};
      },
    },
    layout (context) {
      if (context && context.route) {
        if (+context.route.query.ywtLayoutStyle === 2) {
          return "ywtLayout"
        }
      }
    },
    methods: {
      ywtCallBackFn(event) {
        if (event.origin !== this.globalConfig.domain.ywtOrigin.slice(0, -2)) {
          return false;
        } else {
          if (event.data.type === 'ywtCallBack') {
            this.$nuxt.$emit('menuActiveFn', event.data.oldVal)
          }
        }
      },
      async init() {
        let res = this.currentAuthUser.corpUserId ? await ApiMethods.ProfileController.ywtSystemCorpLogin() : await ApiMethods.ProfileController.ywtSystemLogin();
        if (res.code == 0) {
          this.iframeSrc = `${this.globalConfig.domain.ywtOrigin}/jzqAutoLogin.html?t=${res.data.t}&s=${res.data.s}&corpLoginType=${res.data.corpLogin}&ywtLayoutStyle=${this.$route.query.ywtLayoutStyle}&work=${this.$route.query.work}`
        } else {
          this.$nextTick(() => {
            if (this.$route.path === '/ywtSystem') {
              this.$message.error(res.description)
            }
          })
        }
      },
      ywtChangeMenuFn(obj) {
        this.$refs.ywtIframeRef.contentWindow.postMessage({pageType: obj.value, oldVal: obj.oldVal, type: 'ywtMenuChange'}, this.globalConfig.domain.ywtOrigin)
      },
    },
  }
</script>

<style scoped lang="less">
  .iframe_box {
    width: 1366px;
    margin: 10px auto;
    /*border: 1px solid red;*/
    background-color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// pages/ywtSystem.vue